import { render, staticRenderFns } from "./AddPrivilegeInfo.vue?vue&type=template&id=7ada7b7e&scoped=true&"
import script from "./AddPrivilegeInfo.vue?vue&type=script&lang=js&"
export * from "./AddPrivilegeInfo.vue?vue&type=script&lang=js&"
import style0 from "./AddPrivilegeInfo.vue?vue&type=style&index=0&id=7ada7b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ada7b7e",
  null
  
)

export default component.exports